import axios from 'axios';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import baseURL from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';
import { GiftTable } from './GiftTable';

const GiftServiceList = () => {
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const GetGiftService = `${baseURL}/GiftService/GetSettingsGiftType`;
  const headers = ['sNo', 'Gift Type', 'Activate / Deactivate', 'Add projects'];
  const token = localStorage.getItem('token');
  const { pathname } = useLocation()

  useEffect(() => {
    localStorage.setItem('isHome', false);

    (async () => {
      setIsLoad(true);
      const response = await axios.get(GetGiftService, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        setIsLoad(false);
      }
      setData(response?.data.data);
    })();
  }, [refresh]);

  const refreshRequest = () => {
    setRefresh(!refresh);
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, [])

  const whiteListKeys = ['en_Us', 'activeID'];
  return (
    <div className="">
      <div className="flex flex-col py-5 mt-3 px-3 lg:mx-20">
        <h3 className="font-bold sm:text-2xl p-2 text-xl text-customgreen" style={{ textAlign: 'center' }}>
          {t('Service For Gift')}
        </h3>

        {isLoad ? (
          <LoadingAnimation />
        ) : (
          data.length > 0 && (
            <GiftTable headers={headers} rows={data} whiteListKeys={whiteListKeys} setRefresh={refreshRequest} />
          )
        )}
        {datanotfound && <DataNotFound />}
      </div>
    </div>
  );
};

export default GiftServiceList;
